export default __webpack_public_path__ + "static/media/no-harmful-chemicals.0e5c957b.svg";